import React from 'react';

const FooterComponent = () => {
    return ( 
        <>
            <div className="footer bg-custom">
                <p><i>Copyright &copy; - Carlos Mur</i></p>
            </div>    
        </>
     );
}

export default FooterComponent;